import type { Cell } from '@tanstack/react-table';
import { flexRender } from '@tanstack/react-table';

import type { CatalogItem } from '@/entities/catalog-item';
import { DateTextVariants, useDateText } from '@/features/_shared/user';
import EllipsisWithTooltip from '@/shared/ui/primitives/EllipsisWithTooltip';
import { LaunchBadge } from './LaunchBadge';

const useCatalogTableCell = (columnId: string, cell: Cell<CatalogItem, unknown>) => {
  const { formatDateString } = useDateText();

  const renderContent = () => {
    const cellValue = cell.getValue() as string;
    switch (columnId) {
      case 'Title':
        return <EllipsisWithTooltip text={cellValue} />;
      case 'IndexModule':
      case 'Commodity':
        return <EllipsisWithTooltip text={cellValue.split(',').join(', ')} />;
      case 'LastDate':
      case 'StartDate':
      case 'EndDate':
        return <>{formatDateString(cellValue, DateTextVariants.FULL)}</>;
      case 'LaunchDate':
        return <LaunchBadge launchDate={cellValue} />;
      default:
        return <>{flexRender(cell.column.columnDef.cell, cell.getContext())}</>;
    }
  };

  const defaultStyle = {
    display: 'flex',
    alignItems: 'center',
    width: cell.column.getSize(),
    padding: '1px 8px',
    fontSize: '14px',
    justifyContent: 'flex-start',
    color: 'inherit'
  };
  return { renderContent, defaultStyle };
};

export default useCatalogTableCell;
